import React, {useState} from 'react'
import FloatingNav, {FloatingNavStatus} from "../../components/FloatingNav";
import Header from "../../components/Header";
import Scroll from "react-scroll";
import FooterBar from "../../components/FooterBar";
import RetroComp from "../../components/RetroComp";
import {NextSeo} from "next-seo";


const Index = () => {

    let scroller = Scroll.scroller;

    const [floatingNavStatus, setFloatingNavStatus] = useState<FloatingNavStatus>(
        FloatingNavStatus.RETRO
    );

    const [prompt, setPromptText] = useState<string>('');
    return (
        <>
            <NextSeo
                title={'AI Generated Scrum Retrospectives'}
                description="Get inspired and have some fun generating Scrum Retrospectives with AI! Share them with your team and friends!"
                robotsProps={{
                    nosnippet: true,
                    notranslate: false,
                    noimageindex: true,
                    noarchive: false,
                    maxSnippet: -1,
                    maxImagePreview: 'standard',
                    maxVideoPreview: -1
                }}
                twitter={{
                    handle: '@benithors',
                    site: '@benithors',
                    cardType: 'summary_large_image'
                }}
                openGraph={{
                    url: 'https://www.scrumify.at/airetro',
                    title: "Scrumify - AI Generated Scrum Retrospectives",
                    description: "Powering Up Software Teams.",
                    images: [
                        {
                            url: "https://res.cloudinary.com/bt101/image/upload/v1674077719/opengraph_ai_retro_ieth6r.png",
                            width: 1200,
                            height: 630,
                            alt: "Scrumify - AI Generated Scrum Retrospectives",
                            type: "image/png",
                        },
                    ],
                    site_name: "Scrumify",
                }}
            />
            <FloatingNav scroller={scroller} floatingNavStatus={floatingNavStatus} initialShowStatus={true}/>
            <Header scroller={scroller} floatingNavStatus={floatingNavStatus}/>

            <RetroComp  prompt={prompt} setPromptText={setPromptText} mood={0}/>

            <FooterBar/>
        </>
    );
}

export default Index
